class PetAndOwnerModel {
    constructor(ownerId, ownerName, petId, petName) {
        this.ownerId = ownerId;
        this.ownerName = ownerName;
        this.petId = petId;
        this.petName = petName;
    }

    isPet() {
        return this.petId;
    }
}

export default PetAndOwnerModel;